import React, { useState,useEffect } from "react";
import Verify from "../Verify";
import Loader from "../../components/Loader/Loader";
import axios from "axios";
import { deleteLocalDb } from "../../store";
import * as serviceWorkerRegistration from '../../serviceWorkerRegistration';
import tambola_logo_login from '../../images/brs_logo_1.png';
//import tVideo from '../../videos/tVideo.mp4';
const API_PATH="https://brsinbox.com/API/"
function generateOTP(length = 6) {
  const digits = '0123456789';
  let otp = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * digits.length);
    otp += digits[randomIndex];
  }
  return otp;
}
//const tVideo="https://login.spearup.io/tVideo.mp4";
const apiUrl_vc = API_PATH+"evoltest_vc.php";
const loginUserId=1;
const loginOwnerId=1;
var _inx_version_local=localStorage.getItem("_inx_version_spearUp_tambola");
var userData=localStorage.getItem("_tm_userData"); 
//console.log(userData)
if(typeof _inx_version_local !== "undefined" && (userData === "_lgt" || typeof userData === "undefined" || userData === "" || userData === null)){
	
	const postDataVC = {
	accId: loginOwnerId,
	uId: loginUserId,
	};
	axios.post(apiUrl_vc,postDataVC)
	.then(response => {
	const responseData25 = response.data;
	if(parseInt(responseData25)>0){
		if (typeof _inx_version_local !== "undefined"){ 
			if(parseInt(_inx_version_local) !== parseInt(responseData25)){ 
				localStorage.setItem('_inx_version_spearUp_tambola',responseData25);
				_inx_version_local=localStorage.getItem("_inx_version_spearUp_tambola");
				if(_inx_version_local){
					if('caches' in window){
						caches.keys().then((names) => {
						// Delete all the cache files
						names.forEach(name => {
							let result = name.includes("workbox-precache-v2");								
							if(result){
								caches.delete(name);
							}		   								   
						}) 
						});
					}
					
					if ('serviceWorker' in navigator) {
						navigator.serviceWorker.getRegistrations().then(function (registrations) {
						for (const registration of registrations) {
						// unregister service worker
						console.log('serviceWorker unregistered');
						registration.unregister();

						setTimeout(function(){
						console.log('trying redirect do');
						window.location.replace(window.location.href); // because without redirecting, first time on page load: still service worker will be available
						}, 2000);
						}
						});
					}
					serviceWorkerRegistration.unregisterNdReload({})	
				} 
			}else{
			   serviceWorkerRegistration.register({})
			}
		}else{
			localStorage.setItem('_inx_version_spearUp_tambola',responseData25); 
			serviceWorkerRegistration.register({})
		}
	}
	})
	.catch(error => {
	console.error('Error fetching data:', error);
	});

}

export const Login = () => {
  const [isValid, setIsValid] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [otp, setOtp] = useState("");
  const [userName, setUserName] = useState();
  const [userTitle, setUserTitle] = useState("");

  
  const [accountName2, setAccountName2] = useState("Sign in to your Account");
  const [formData, setFormData] = useState({
    UserName: "",
    UserTitle: "",
  });
  
  const [errors, setErrors] = useState({
    UserName: "",
    UserTitle: "",
    apiError: "",
  });
  
const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "UserName") {
    const digitsOnly = value.replace(/\D/g, "").slice(0, 10);

    setFormData(prev => ({
      ...prev,
      [name]: digitsOnly
    }));

    setErrors(prev => ({
      ...prev,
      apiError: ""
    }));
  }else {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    setErrors(prev => ({
      ...prev,
      apiError: ""
    }));
  }
};

	const stopAllVideo = () => {
	  // HTML5
	  document.querySelectorAll("video").forEach(v => {
		v.pause();
		v.currentTime = 0;
	  });

	  // YouTube iframe
	  document.querySelectorAll("iframe").forEach(f => {
		f.contentWindow?.postMessage(
		  '{"event":"command","func":"stopVideo","args":""}',
		  "*"
		);
	  });
	};

  // const navigate = useNavigate();

  //const isValid = isFormValid(formData, errors);
  const handleSubmit = async () => {
	
    await deleteLocalDb();
	
    localStorage.setItem("_tm_isHome", "N");

    const { UserName, UserTitle } = formData;
	
	var fourDigitOtp = generateOTP(4); 
	//fourDigitOtp = 1234; 
	setOtp(fourDigitOtp);
	setUserName(UserName);
	setUserTitle(UserTitle);
	if(UserName === ""){   
	   setErrors({ apiError: "Please enter mobile!"});
	}else{
		if(UserName.length <= 9){   
		setErrors({ apiError: "Please enter 10 digits mobile!"});
		}
	}
	if(UserTitle === ""){   
	setErrors({ apiError: "Please enter your name!"});
	}
	if(UserName && UserTitle  && UserName.length === 10){
		setIsValid(true);
		const ac2=localStorage.getItem("_tm_laccId");
		callAppTrack(ac2,UserName,fourDigitOtp,1); 
		const payload = {
		  api4m:"1",
		  logicType:"2",
		  userName: UserName,
		  userTitle: UserTitle,
		  _tps_val: fourDigitOtp,
		};
		setIsLoader(true);
		axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
		axios
		  .post(API_PATH+"senttps.php",payload)
		  .then((response) => {
			console.log("Response Data:", response.data);
			if (response?.data?.Status === "1" || response?.data?.Status === 1) {
				setIsValid(true);
				setIsLogin(true);
				setIsLoader(false);
				localStorage.setItem("_tm_lmno", UserName);
				stopAllVideo();
			}else{
				 setIsValid(false);
				 setIsLoader(false);
				 setErrors({ apiError: "Network issue, please try again!!"});
			}
		  })
		  .catch((error) => {
			  setIsLoader(false);
			setErrors({ apiError: error });
		  });
	}
	 return false;
   };
   const resetDtls = () => {
	   setIsLoader(false);
	   setErrors({ apiError: "" });
   };
    const callAppTrack = async (ac,pn,info,t_type) => {
		const payload4 = {
		  mno: pn,
		  ownerId: ac,
		  info: info,
		  t_type: t_type,
		};
		axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
		axios
		  .post(API_PATH+"api/app_track.php",payload4)
		  .then((response) => {
			//console.log("Response Data:", response.data);
		  })
		  .catch((error) => {
			setErrors({ apiError: error });
		  });
	}
	
	useEffect(() => {
		console.log("login RENDER");
	  localStorage.setItem("pwa_install_dismissed", "");	
	  let params = new URLSearchParams(window.location.search);

	  let pn = params.get("pn"); // phone number
	  let ac = params.get("ac"); // account code
	  let ut = params.get("ut"); // User Title
	  if(ac == "" || ac == "-" || ac == "null"){ 
	    ac="24397";
	  }
	  localStorage.setItem("_tm_laccId", ac);
      callAppTrack(ac,pn,ut,0); 
	  // ✅ Auto-fill mobile number
	  if (pn && /^\d{10}$/.test(pn)) {
		setFormData(prev => ({
		  ...prev,
		  UserName: pn,
		  UserTitle: ut
		}));
	  }
	   if(ut && pn){ 
	   
			var fourDigitOtp2 = generateOTP(4); 
			setOtp(fourDigitOtp2);
			setUserName(pn);
			setUserTitle(ut);
			if(pn && ut  && pn.length === 10){
				stopAllVideo();
				setIsValid(true);
				const payload2 = {
				  api4m:"1",
				  logicType:"2",
				  userName: pn,
				  userTitle: ut,
				  _tps_val: fourDigitOtp2,
				};
				setIsLoader(true);
				axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
				axios
				  .post(API_PATH+"senttps.php",payload2)
				  .then((response) => {
					console.log("Response Data:", response.data);
					if (response?.data?.Status === "1" || response?.data?.Status === 1) {
						setIsValid(true);
						setIsLogin(true);
						setIsLoader(false);
					}else{
						 setIsValid(false);
						 setIsLoader(false);
						 setErrors({ apiError: "Network issue, please try again!!"});
					}
				  })
				  .catch((error) => {
					  setIsLoader(false);
					setErrors({ apiError: error });
				  });
			}
	   }else{
		  // ✅ Fetch account name
		  if (ac) {
			axios
			  .post(API_PATH + "getAccountName.php", { accountId: ac })
			  .then(res => {
				if (res?.data?.accountName) {
				  localStorage.setItem("_tm_laccId", ac);
				  setAccountName2(res.data.accountName);
				 
				}
			  })
			  .catch(err => {
				console.error("Account name fetch failed", err);
			  });
		  }
	   }
	  
	}, []);


 
  return (
 <>  <div>  {isLoader?<Loader/>:<span></span>} {isLogin?<Verify otp={otp} userName={userName} userTitle={userTitle} />:<div>
 
 <div className="logo-section">
    <img src={tambola_logo_login} alt={tambola_logo_login} className="logo" />
    <div className="brand-name">
        BRS
    </div>
    <div className="brand-tagline">
        Bharat Rashtra Samithi
    </div>
</div>
   
   <div className="login-wrapper"><div id="login-form" className="login-card"><h2>{accountName2}</h2>{errors?.["apiError"] && (<div className="error-message">{errors?.["apiError"]}</div>)}
   
<div className="form-group">
   <input
  type="text"
  id="usertitle-field"
  name="UserTitle"
  placeholder="Enter Your Name"
  value={formData.UserTitle}
  onClick={resetDtls}
  onChange={handleChange}
  autoComplete="off"
/> 
</div>
<div className="form-group">
<input
  type="text"
  id="username-field"
  name="UserName"
  placeholder="Enter Mobile Number"
  value={formData.UserName}
  inputMode="numeric"
  pattern="[0-9]*"
  maxLength={10}
  onClick={resetDtls}
  onChange={handleChange}
  autoComplete="off"
/></div><div className="checkbox mb-1 text-right"></div><input type="submit" value="NEXT" className="btn-primary btn-block" disabled={isValid} onClick={handleSubmit}/></div></div><footer>
    © 2025 www.spearon.com All rights reserved.
  </footer><span id="PING_IFRAME_FORM_DETECTION" style={{display: "none"}}></span></div>  } </div>   
 </>
  ); 
};

export default Login;
